<div class="questionnaire-head-photo-layout">
  <img src="{{origin}}{{questionnaireHeadPhotoUrlArray[questionnaireLevel].description}}" alt="" />
</div>



// WEBPACK FOOTER //
// ./src/component/questionnire/child-photo-head/component.questionnaire-head-photo.html